import { render, staticRenderFns } from "./ServicePage.vue?vue&type=template&id=8f182456&scoped=true&"
import script from "./ServicePage.vue?vue&type=script&lang=js&"
export * from "./ServicePage.vue?vue&type=script&lang=js&"
import style0 from "./ServicePage.vue?vue&type=style&index=0&id=8f182456&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f182456",
  null
  
)

export default component.exports